// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"2e9733e8","251":"460e0125","334":"690ca198","433":"100b8fd2","512":"4b622da9","517":"d88444c5","521":"665fe47b","640":"10886090","655":"1ef5eafa","705":"48ee0fff","729":"608088f0"}[chunkId] + ".chunk.css";
};